<template>
  <div>
    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
      <p class="title"><strong>Pesquisa</strong></p>
      <form class="mt-1 w-full" @submit.prevent="reloadTable">
        <div class="flex flex-wrap mb-4 px-4">
          <multi-select-input v-model="filters.Provider.providers" :multiple="true" :options="providerSearch"
            class="lg:pr-6 w-full lg:w-1/4" label="Fornecedor" />

          <mask-input class="lg:pr-6 w-full lg:w-1/4" mask="##.###.###/####-##" label="CNPJ"
            v-model="filters.Provider.cnpj" />
        </div>

        <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
          <button
            class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out">
            <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
            Pesquisar
          </button>

          <button
            class="btn flex items-center text-purple-100 font-roboto font-medium uppercase px-6 py-2.5 text-xs leading-tight border-sol  id border-2 border-purple-100"
            @click="clearSearch">
            <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
            Limpar
          </button>
        </div>
      </form>
    </div>

    <Head title="Fornecedores" />
    <div class="shadow_box rounded-lg p-6 mt-4">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Fornecedores</h1>
      <data-table v-if="loadTable" v-model:columns="columns" route="provider/list" :query="getQuery"
        no-data-label="Nenhum fornecedor cadastrado" no-result-label="Nenhum fornecedor encontrado">
        <template #table.cell.content.provider_username="{ value, row }">
          <div class="flex items-center gap-2" v-if="row.user_name">
            <span class="font-mono text-xs bg-gray-100 px-2 py-1 rounded border border-gray-300"
              :title="'Login: ' + row.user_name">{{ row.user_name }}</span>
            <button type="button" @click="copyUserName(row.user_name)"
              :title="copiedUserName === row.user_name ? 'Copiado!' : 'Copiar usuário'"
              class="relative text-[10px] uppercase bg-purple-100 text-white px-2 py-1 rounded hover:bg-purple-200 focus:outline-none">
              <span v-if="copiedUserName === row.user_name">Copiado!</span>
              <span v-else>Copiar</span>
            </button>
          </div>
          <span v-else class="text-xs text-gray-400 italic">-</span>
        </template>
        <template #table.cell.content.provider_email="{ value, row }">
          <div class="flex items-center gap-2" v-if="row.email">
            <span class="text-xs break-all">{{ row.email }}</span>
            <button v-if="row.user_id" @click.prevent="openConfirmResend(row)" type="button"
              class="text-[10px] px-2 py-0.5 rounded bg-purple-100 text-white hover:bg-purple-200 focus:outline-none"
              :title="'Reenviar credenciais para ' + row.email">
              <font-awesome-icon icon="fa-paper-plane" />
            </button>
          </div>
          <span v-else class="text-xs italic text-gray-400">-</span>
        </template>
        <template #table.cell.content.detail="{ value, row }">
          <div class="place-self-center grid-cols-1 gap-4">
            <span class="flex items-center justify-center text-sm">
              <Link :href="'brand/' + row.id" class="rounded p-2 bg-purple-100 text-white">
              Ver Marca<font-awesome-icon icon="fa-solid fa-angle-right" class="pl-2" />
              </Link>
            </span>
          </div>
        </template>
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-flex grid-cols-4 gap-3 ">
            <span @click.prevent="openModalConfig(row)"
              class="inline-flex bg-aproved text-white rounded p-2 cursor-pointer text-sm">
              <img src="/images/phone.png" class="w-5 h-5 mr-2" />Vincular Número(s)
            </span>
            <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-pencil" class="text-white mr-2" />Editar
            </span>
            <span @click="openModalConfirmDelete(row)"
              class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-trash-can" class="text-white mr-2" />Excluir
            </span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-flex grid-cols-4 gap-3 ">
            <span @click.prevent="openModalConfig(row)"
              class="bg-aproved text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-pencil" class="text-white pl-2" />Vincular Número(s)
            </span>
            <span @click="openModalEdit(row)" class="bg-purple-200 text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-pencil" class="text-white pr-2" />Editar
            </span>
            <span @click="openModalConfirmDelete(row)"
              class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
              <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />Excluir
            </span>
            <span v-if="row.user_id"
              class="self-center ml-2 bg-green-600 text-white text-[10px] px-2 py-1 rounded uppercase tracking-wider h-fit">Usuário</span>
          </div>
        </template>

        <template #after.reload-button>
          <button class="flex items-end font-roboto font-medium btn-purple uppercase"
            @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block">
              Adicionar Fornecedor</span>
          </button>
        </template>
      </data-table>
    </div>
    <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
    <modal-edit ref="modalEdit" title="Fornecedores" url="provider" @submitForm="reloadTable">
      <template #form="{ item }">
        <text-input v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full lg:w-3/4" label="Nome"
          required="*" />

        <mask-input v-model="item.cnpj" mask="##.###.###/####-##" :error="item.errors.cnpj"
          class="lg:pr-6 w-full lg:w-3/4 mt-6" label="CNPJ" required="*" />

        <text-input v-model="item.email" :error="item.errors.email" type="email" class="lg:pr-6 w-full lg:w-3/4 mt-6"
          label="E-mail (opcional)" />
      </template>
    </modal-edit>

    <modal ref="modalConfig" size="modal-lg" :modal-scrollable="true" :modal-backdrop="true" id="modal-config">
      <template #header>
        <div class="text-gray-777 font-roboto uppercase">
          <span>Vincular Grupos e Número(s)</span>
        </div>
      </template>
      <template #body>
        <tabs ref="tabsRef" :items="tabs" @change-tab="handlerChangeTab">
          <template #content.tab-groups>
            <div class="mt-7 w-full">
              <div v-if="this.status != 'connected'" class="w-[162px] h-[100px] mx-auto">
                <p class="text-base mb-2 text-center">Conectando ao WhatsApp...</p>
              </div>

              <div v-else-if="this.status == 'connected'" class="w-full">
                <multi-select-input-whatsapp-group appendTo="#modal-config" v-model="formConfig.groups_selected"
                  :multiple="true" :options="formConfig.groups_options" class="lg:pr-6 w-full lg:w-1/2 mt-6 mb-6"
                  label="Grupos" />

                <div style="display:inline-flex" v-for="grupo in this.groups_adicionados">
                  <span
                    style="border: 1px solid; border-color: #d0c6c6; border-radius: 10px; padding: 10px; margin-right: 5px">
                    <label>{{ grupo.label }} </label>&nbsp;&nbsp;
                    <span @click.prevent="excluirGrupoAdicionado(grupo, grupo.value, formConfig.parent_id)"
                      class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                      <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </template>

          <template #content.tab-numbers>
            <div class="mt-7 w-full">
              <div style="display:inline-flex; align-items: flex-end;">
                <mask-input :mask="['(##) #####-####']" :clear-incomplete="true" v-model="formConfig.phone"
                  class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Número" />
                <button class="flex items-end font-roboto font-medium btn-purple uppercase"
                  @click.prevent="addNumero(formConfig.phone, formConfig.parent_id)">
                  <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span
                    class="hidden lg:block">
                    Adicionar</span>
                </button>
              </div>
              <div v-if="this.numeroValidado == 'não'" style="display:inline-flex; align-items: flex-end; color:red;">
                O número deve ter 15 caracteres. E seguir o padrão (xx) xxxxx-xxxx
              </div>
              <div style="width:100%; display:inline-grid">
                <div style="display:inline-flex;  align-items: flex-end; margin-top: 15px;"
                  v-for="numero in this.numeros_adicionados">
                  <span
                    style="border: 1px solid; border-color: #d0c6c6; border-radius: 10px; padding: 10px; margin-right: 5px">
                    <label>{{ numero.label }} </label>&nbsp;&nbsp;
                    <span @click.prevent="excluirNumeroAdicionado(numero, numero.value, formConfig.parent_id)"
                      class="bg-red_delete text-white rounded p-2 cursor-pointer text-sm">
                      <font-awesome-icon icon="fa-trash-can" class="text-white text-lg pr-2" />
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </template>
        </tabs>

      </template>
      <template #footer>
        <button type="button"
          class="px-6 py-2.5 bg-gray-600 text-white font-roboto font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out"
          @click.prevent="closeModalConfig">Cancelar</button>
        <loading-button :loading="loadModalConfig" class="btn-primary px-6 py-2.5 text-xs leading-tight uppercase ml-1"
          @click.prevent="saveModalConfig" type="submit">Salvar</loading-button>
      </template>
    </modal>

    <modal ref="modalResend" :modal-backdrop="true" :modal-scrollable="false" id="modal-resend">
      <template #header>
        <div class="text-gray-777 font-roboto uppercase">Confirmar Reenvio</div>
      </template>
      <template #body>
        <p class="text-sm leading-relaxed" v-if="resendTarget">
          Deseja realmente reenviar as credenciais para
          <strong>{{ resendTarget.email }}</strong>?
        </p>
      </template>
      <template #footer>
        <button type="button" class="px-4 py-2 bg-gray-500 text-white text-xs uppercase rounded hover:bg-gray-600"
          @click="closeResendModal">Cancelar</button>
        <button type="button"
          class="ml-2 px-4 py-2 bg-purple-100 text-white text-xs uppercase rounded hover:bg-purple-200 disabled:opacity-60"
          :disabled="resendLoading" @click="confirmResend">{{ resendLoading ? 'Enviando...' : 'Reenviar' }}</button>
      </template>
    </modal>

  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import Modal from '@/Shared/Modal'
import TextInput from '@/Shared/TextInput'
import DataTable from '@/Shared/DataTable'
import MaskInput from '@/Shared/MaskInput'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import Tabs from '@/Shared/Tabs/Tabs.vue'
import MultiSelectInputWhatsappGroup from '../../../Shared/MultiSelectInputWhatsappGroup.vue'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import {
  getWhatsappSessionUuid,
  getWhatsappGroups,
} from "../../WhatsappConection/whatsapp";
import { whatsappConnection } from "../../WhatsappConection/socket";

const tabs = [
  {
    idTab: 'tab-groups',
    title: 'Grupos',
    content: 'groups',
  },
  {
    idTab: 'tab-numbers',
    title: 'Números',
    content: 'numbers',
  },

]

export default {
  components: {
    Head,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    TextInput,
    DataTable,
    MaskInput,
    Link,
    MultiSelectInput,
    Modal,
    Tabs,
    MultiSelectInputWhatsappGroup,

  },
  layout: Layout,

  props: {
    providerSearch: {
      type: Array,
      required: true,
    }
  },

  data() {
    return {
      loadTable: true,
      loadModalConfig: false,
      columns: [
        {
          uniqid: 'provider_name',
          label: 'Fornecedor',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'provider_email',
          label: 'E-mail',
          field: 'email',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-3 text-left',
        },
        {
          uniqid: 'provider_username',
          label: 'Usuário (login)',
          field: 'user_name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-xs whitespace-nowrap',
          headerClass: 'p-3 text-left',
        },
        {
          uniqid: 'provider_cnpj',
          label: 'CNPJ',
          field: 'cnpj',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-3 text-left',
        },
        {
          uniqid: 'detail',
          label: 'Marca',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
      session: "",
      status: "",
      groups_options: [],
      groups_selected: [],
      groups_add: [],
      selectedTab: '',
      groups_adicionados: [],
      numeros_adicionados: [],
      numeroValidado: "",
      copyFeedback: null,
      copiedUserName: null,
      showResendConfirm: false,
      resendTarget: null,
      resendLoading: false,
    }
  },

  mounted() {
    this.clearSearch()
  },

  computed: {
    getQuery() {
      return Object.entries(this.getFilters()).map(([key, val]) => `search2[${key}]=${val}`).join('&')
    },
  },

  methods: {
    handlerChangeTab(event) {
      this.selectedTab = event.selectedTab
    },
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/provider/${item.id}`, `Deseja realmente excluir o fornecedor ${item.name}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        errors: {}
      });
    },
    async addNumero(phone, parent_id) {
      if (phone.length < 15) {
        this.numeroValidado = "não";
        return;
      }
      this.numeroValidado = "sim";
      this.formConfig.post(`/provider/addwhatsappnumber/` + parent_id + `/` + phone, {
        onFinish: () => {

          if (!Object.keys(this.formConfig.errors).length) {
            this.numeros_adicionados.push({ value: phone, label: phone });
            this.numeroValidado = "sim";
          } else {
            this.loadModalConfig = false;
          }
        }
      });

    },
    async excluirGrupoAdicionado(grupo, grupoId, parent_id) {
      this.formConfig.post(`/provider/delete-whatsappgroup/` + parent_id + `/` + grupoId, {
        onFinish: () => {
          if (!Object.keys(this.formConfig.errors).length) {
            this.groups_adicionados.splice(this.groups_adicionados.indexOf(grupo), 1);
          } else {
            this.loadModalConfig = false;
          }
        }
      });
    },
    async excluirNumeroAdicionado(numero, numeroId, parent_id) {
      this.numeroValidado = "sim";
      this.formConfig.post(`/provider/delete-whatsappnumber/` + parent_id + `/` + numeroId, {
        onFinish: () => {
          if (!Object.keys(this.formConfig.errors).length) {
            this.numeros_adicionados.splice(this.numeros_adicionados.indexOf(numero), 1);
          } else {
            this.loadModalConfig = false;
          }
        }
      });
    },
    async loadGroupsWhatsProvider(id) {

      await fetch(
        `/provider/get-whatsappgroup/` + id
      ).then(res => {
        res.json().then(json => {
          if (Array.isArray(json.groupsList)) {
            json.groupsList.forEach((group) => {
              this.groups_add.push({ value: group.value });
            });
          }

        });
      });
    },
    async loadNumbersWhatsProvider(id) {

      await fetch(
        `/provider/get-whatsappnumber/` + id
      ).then(res => {
        res.json().then(json => {
          if (Array.isArray(json.groupsList)) {
            json.groupsList.forEach((group) => {
              this.numeros_adicionados.push({ value: group.value, label: group.value });
            });
          }

        });
      });
    },
    async openModalConfig(item) {
      this.groups_add = [];
      this.groups_options = [];
      this.groups_selected = [];
      this.groups_adicionados = [];
      this.numeros_adicionados = [];

      console.log(item.id)

      await this.loadGroupsWhatsProvider(item.id);
      await this.loadNumbersWhatsProvider(item.id);
      this.getWhatsappSession();

      this.formConfig = useForm({
        parent_id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        phone: '',
        groups_options: this.groups_options,
        groups_selected: this.groups_selected,
        errors: {}
      });

      this.$refs.modalConfig.showModal = true;
    },
    closeModalConfig() {
      this.$refs.modalConfig.showModal = false;
    },
    saveModalConfig() {

      this.formConfig.post(`/provider/whatsappgroup`, {
        onFinish: () => {
          if (!Object.keys(this.formConfig.errors).length) {
            this.closeModalConfig();
            this.reloadTable();
          } else {
            this.loadModalConfig = false;
          }
        }
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    clearSearch() {
      this.clearFilters()
      this.reloadTable();
    },

    async findWhatsappGroups(sessionName) {
      try {
        const response = await getWhatsappGroups(sessionName)

        const idsGroupsAlreadyAdded = this.groups_add.map(group => group.value)
        this.groups_options = response.map(
          group => ({
            value: group.id,
            label: group.subject
          })
        )

        this.groups_adicionados = this.groups_options.filter(
          group => idsGroupsAlreadyAdded.includes(group.value)
        )

        this.formConfig.groups_options = this.groups_options
        this.formConfig.groups_adicionados = this.groups_adicionados

        this.status = 'connected'
      }
      catch (err) {
        this.status = "error";
        this.errorMessage = err.message;
      }
    },

    async getWhatsappSession() {
      try {
        const response = await getWhatsappSessionUuid();

        this.session = response.id
        this.username = response.name

        this.status = "starting";

        if (response.connectionStatus == "close" || response.connectionStatus == "connecting") {
          this.status = "error";
          this.errorMessage = "Whatsapp desconectado, se reconecte para prosseguir";
        }
        else {
          this.findWhatsappGroups(response.instanceName)
        }

      } catch (err) {
        this.status = "error";
        this.errorMessage = err.message;
      }
    },
    resendCredentials(row) {
      if (!row || !row.id) { return; }
      this.openConfirmResend(row);
    },
    openConfirmResend(row) {
      if (!row || !row.id) return;
      this.resendTarget = { id: row.id, email: row.email };
      if (this.$refs.modalResend) {
        this.$refs.modalResend.open();
      }
    },
    sendResendRequest() {
      if (!this.resendTarget || this.resendLoading) return;
      this.resendLoading = true;
      if (!this.$axios && typeof axios === 'undefined') {
        try { window.axios = require('axios'); } catch (e) { }
      }
      const client = this.$axios || window.axios;
      if (!client) { this.resendLoading = false; return; }
      client.post(`/provider/${this.resendTarget.id}/resend-credentials`)
        .then(() => { this.reloadTable(); })
        .catch(() => { /* erro silencioso */ })
        .finally(() => { this.resendLoading = false; this.closeResendModal(); });
    },
    closeResendModal() {
      if (this.$refs.modalResend) {
        this.$refs.modalResend.close();
      }
      this.resendTarget = null;
      this.resendLoading = false;
    },
    confirmResend() {
      this.sendResendRequest();
    },
    copyUserName(userName) {
      if (!userName) return;
      const doMark = () => {
        this.copiedUserName = userName;
        setTimeout(() => { if (this.copiedUserName === userName) this.copiedUserName = null; }, 2000);
      };
      const fallback = () => {
        try {
          const temp = document.createElement('textarea');
          temp.value = userName;
          temp.setAttribute('readonly', '');
          temp.style.position = 'fixed';
          temp.style.top = '-1000px';
          document.body.appendChild(temp);
          temp.select();
          document.execCommand('copy');
          document.body.removeChild(temp);
          doMark();
        } catch (e) {
          // ignore
        }
      };
      try {
        if (navigator && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          navigator.clipboard.writeText(userName).then(() => doMark()).catch(fallback);
        } else {
          fallback();
        }
      } catch (e) {
        fallback();
      }
    },
  },

  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent('Provider')

    const clearFilters = () => clearFiltersComponent('Provider')
    const getFilters = () => getFiltersComponent('Provider')

    return {
      getFilters,
      clearFilters,
      filters: filtersStore.filters,
      tabs
    }
  }
}
</script>
